export const restPrefixV1 = '/apps/backend/v1';
export const restPrefixV2 = '/apps/backend/v2';
export const onlineInquiryPrefix = '/tarr/ugyfelkapu/public/tudakozo';

export const SZOLGALTATASOK = `${restPrefixV1}/szolgaltatasok`;
export const MOBILTV_SZOLGALTATASOK = `${restPrefixV1}/szolgaltatasok/mobiltv`;
export const CSATORNA_KIOSZTASOK = `${restPrefixV1}/csatorna-kiosztasok`;
export const CSATORNA_KIOSZTASOK_PDF = `${restPrefixV1}/csatorna-kiosztasok/csatornakiosztas-pdf`;
export const HUSEGIDOK = `${restPrefixV1}/husegidok`;
export const KOMBI_PACKAGES = `${restPrefixV1}/szolgaltatasok/kombi`;
export const SZOLGALTATASOK_KIVALASZT = `${restPrefixV1}/szolgaltatasok/kivalaszt`;
export const FEATURED_CHANNEL_URL = `${restPrefixV1}/kiemelt-csatornak`;
export const CUSTOMER_SERVICE_URL = '/sw/json/customer-service.json';
export const SALES_POINTS_URL = '/sw/json/sales-points.json';
export const CURRENT_DATE = '/apps/backend/common/current-date';
export const SEARCH_API_URL = `${restPrefixV2}/webshop/search`;

export const INTERNET_PATH = '/internet';
export const MOBILE_PATH = '/mobil';
export const MOBILE_INTERNET_PATH = '/mobil-internet';
export const TELEPHONE_PATH = '/telefon';
export const TV_PATH = '/tv';
export const DKTV_PATH = '/dktv';
export const KOMBI_PATH = '/kombi';

export const SEARCH_IN_CONTENTS_URL = '/apps/search/do';
export const SEARCH_IN_WEB_ITEMS_URL = `${restPrefixV2}/webshop/search-freetext`;

export const ONLINE_INQUIRY_SEARCH_URL = `${onlineInquiryPrefix}/getKombinaltKereses`
export const ONLINE_INQUIRY_GET_SETTLEMENTS_URL = `${onlineInquiryPrefix}/getLefedettTelepulesek`
export const ONLINE_INQUIRY_GET_STREETS_URL = `${onlineInquiryPrefix}/getLefedettUtcak`
export const ONLINE_INQUIRY_GET_HOUSE_NUMBERS_URL = `${onlineInquiryPrefix}/getLefedettHazszamok`



// WEBPACK FOOTER //
// ../source/common/api/urls.js